var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labels-condition"},[_c('include-exclude-condition-mode',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.condition.mode),callback:function ($$v) {_vm.$set(_vm.condition, "mode", $$v)},expression:"condition.mode"}}),_c('select-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.condition,
        'key': 'values',
        'options': _vm.labelsOptions,
        'multiple': true,
        'disabled': _vm.disabled
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }